import Trustpilot from "./Trustpilot";

export { Trustpilot };
